import { defineComponent as _defineComponent } from 'vue'
import i18n from '@/initI18n';

import { reportState } from '@/map/composables/useReportState';
import Orientation from '@/map/types';
import ButtonWithArrow from '@/shared/components/buttons/ButtonWithArrow.vue';
import FormFieldInput from '@/shared/components/form/FormFieldInput.vue';
import FormFieldRadioGroup from '@/shared/components/form/FormFieldRadioGroup.vue';
import FormRadio from '@/shared/components/form/FormRadio.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarCreateReport',
  emits: ["close", "onUpdateLegendTitle", "export:report"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'onUpdateLegendTitle', title: string): void;
  (e: 'export:report', value: { orientation: Orientation; legendTitle: string }): void;
}), expose: any, slots: any, attrs: any }) {

const $t = i18n.translate;

/* EMITS */


/* METHODS */
function exportReport(): void {
  emit('export:report', {
    orientation: reportState.orientation,
    legendTitle: reportState.legendTitle === '' ? $t('Legend')! : reportState.legendTitle,
  });
}

function onUpdateLegendTitle(value: string) {
  reportState.legendTitle = value;
}

function onUpdateOrientation(value: Orientation) {
  reportState.orientation = value;
}

function closeSidebar() {
  reportState.legendTitle = '';
  reportState.orientation = Orientation.PORTRAIT;
  emit('close');
}

return { __sfc: true,$t, emit, exportReport, onUpdateLegendTitle, onUpdateOrientation, closeSidebar, reportState, Orientation, ButtonWithArrow, FormFieldInput, FormFieldRadioGroup, FormRadio }
}

})